import {
  manualPanCheck,
  manualDrugCheck,
  manualReferenceCheck,
  manualAadhaarCheck,
  manualBankCheck,
  manualDLCheck,
  manualIRRDCheck,
  manualVoterIdCheck,
  manualUANCheck,
  manualGlobalCheck,
  manualFACISCheck,
  manualIndianCreditHistoryCheck,
  manualAddressCheck,
  manualEducationUpload,
  manualCheckSaveEduEmp,
  manualEmploymentUpload, educationInsufficient, getInsufficientDetails, fetchInsufficientApprove, approveEducationInsufficient, rejectInsufficient,
  approveEmploymentInsufficient,
  SubmitEmploymentGap,
  ConcludeEmploymentGap,
  uanInformationVerification
} from "../actions/AdminRunChecksAction";
import { createSlice } from "@reduxjs/toolkit";

const manualPanCheckSlice = createSlice({
  name: "manualPanCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualPanCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualPanCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualPanCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualDrugCheckSlice = createSlice({
  name: "manualDrugCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualDrugCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualDrugCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualDrugCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualReferenceCheckSlice = createSlice({
  name: "manualReferenceCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualReferenceCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualReferenceCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualReferenceCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualAadharCheckSlice = createSlice({
  name: "manualAadharCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualAadhaarCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualAadhaarCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualAadhaarCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualVoterIdCheckSlice = createSlice({
  name: "manualVoterIdCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualVoterIdCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualVoterIdCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualVoterIdCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualBankCheckSlice = createSlice({
  name: "manualBankCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualBankCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualBankCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualBankCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualDLCheckSlice = createSlice({
  name: "manualDLCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualDLCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualDLCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualDLCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualIRRDCheckSlice = createSlice({
  name: "manualIRRDCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualIRRDCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualIRRDCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualIRRDCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualUANCheckSlice = createSlice({
  name: "manualUANCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualUANCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualUANCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualUANCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const uanInformationVerificationSlice = createSlice({
  name: "uanInformationVerification",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uanInformationVerification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uanInformationVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(uanInformationVerification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualGlobalCheckSlice = createSlice({
  name: "manualGlobalCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualGlobalCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualGlobalCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualGlobalCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualFACISCheckSlice = createSlice({
  name: "manualFACISCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualFACISCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualFACISCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualFACISCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualIndianCreditHistoryCheckSlice = createSlice({
  name: "manualIndianCreditHistoryCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualIndianCreditHistoryCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualIndianCreditHistoryCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualIndianCreditHistoryCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualAddressCheckSlice = createSlice({
  name: "manualAddressCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualAddressCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualAddressCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualAddressCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualEducationUploadSlice = createSlice({
  name: "manualEducationUpload",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualEducationUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualEducationUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualEducationUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualEmploymentUploadSlice = createSlice({
  name: "manualEmploymentUpload",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualEmploymentUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualEmploymentUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualEmploymentUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualCheckSaveEduEmpSlice = createSlice({
  name: "manualCheckSaveEduEmp",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualCheckSaveEduEmp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualCheckSaveEduEmp.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualCheckSaveEduEmp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const educationInsufficientSlice = createSlice({
  name: "educationInsufficient",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(educationInsufficient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(educationInsufficient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(educationInsufficient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getInsufficientDetailsSlice = createSlice({
  name: "getInsufficientDetails",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInsufficientDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInsufficientDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getInsufficientDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const fetchInsufficientApproveSlice = createSlice({
  name: "fetchInsufficientApprove",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInsufficientApprove.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInsufficientApprove.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(fetchInsufficientApprove.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const approveEducationInsufficientSlice = createSlice({
  name: "approveEducationInsufficient",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(approveEducationInsufficient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveEducationInsufficient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(approveEducationInsufficient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const rejectInsufficientSlice = createSlice({
  name: "rejectInsufficient",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rejectInsufficient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectInsufficient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(rejectInsufficient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const approveEmploymentInsufficientSlice = createSlice({
  name: "approveEmploymentInsufficient",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(approveEmploymentInsufficient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveEmploymentInsufficient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(approveEmploymentInsufficient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const SubmitEmploymentGapSlice = createSlice({
  name: "SubmitEmploymentGap",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SubmitEmploymentGap.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SubmitEmploymentGap.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(SubmitEmploymentGap.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const ConcludeEmploymentGapSlice = createSlice({
  name: "ConcludeEmploymentGap",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ConcludeEmploymentGap.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ConcludeEmploymentGap.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(ConcludeEmploymentGap.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});



export const reducers = {
  manualPanCheck: manualPanCheckSlice.reducer,
  manualDrugCheck: manualDrugCheckSlice.reducer,
  manualReferenceCheck: manualReferenceCheckSlice.reducer,
  manualAadhaarCheck: manualAadharCheckSlice.reducer,
  manualVoterIdCheck: manualVoterIdCheckSlice.reducer,
  manualBankCheck: manualBankCheckSlice.reducer,
  manualDLCheck: manualDLCheckSlice.reducer,
  manualIRRDCheck: manualIRRDCheckSlice.reducer,
  manualUANCheck: manualUANCheckSlice.reducer,
  manualGlobalCheck: manualGlobalCheckSlice.reducer,
  manualFACISCheck: manualFACISCheckSlice.reducer,
  SubmitEmploymentGap: SubmitEmploymentGapSlice.reducer,
  ConcludeEmploymentGap: ConcludeEmploymentGapSlice.reducer,
  manualIndianCreditHistoryCheck: manualIndianCreditHistoryCheckSlice.reducer,
  manualAddressCheck: manualAddressCheckSlice.reducer,
  manualEducationUpload: manualEducationUploadSlice.reducer,
  manualEmploymentUpload: manualEmploymentUploadSlice.reducer,
  manualCheckSaveEduEmp: manualCheckSaveEduEmpSlice.reducer,
  educationInsufficient: educationInsufficientSlice.reducer,
  getInsufficientDetails: getInsufficientDetailsSlice.reducer,
  fetchInsufficientApprove: fetchInsufficientApproveSlice.reducer,
  approveEducationInsufficient: approveEducationInsufficientSlice.reducer,
  rejectInsufficient: rejectInsufficientSlice.reducer,
  approveEmploymentInsufficient: approveEmploymentInsufficientSlice.reducer,
  uanInformationVerification:uanInformationVerificationSlice.reducer
};
